
import {actionCreators} from '../../store/Account';
import {connect} from 'react-redux'

import RedirectHandler from './RedirectHandler';

// const RedirectRoute = ({
    
//     ...rest
// }) => (

//     <Route
//         {...rest}
//         render={props => (<RedirectHandler {...props}/>)}
//     />
// )

const mapStateToProps = (state) => ({
    account: state.account && state.account.account
        ? state.account.account.value
        : null
});

const mapDispatchToProps = dispatch => ({
    accountSelected: (account) => dispatch(actionCreators.accountSelected(account))
});

export default connect(mapStateToProps, mapDispatchToProps)(RedirectHandler);
